// Which Digital Delivery tab an item belongs in, from its dates rather than
// the status saved at its last edit (that status goes stale: an item saved
// as "upcoming" stays "upcoming" after it goes live, and a published item
// stays "current" after its Show as Current Until date passes).
//
//   history  - archived, or Show as Current Until has passed
//   upcoming - not yet published (in review / draft), or Publish On is in
//              the future
//   current  - everything else (published and still inside its window)
const parseTime = (value) => {
  const time = Date.parse(value || "");
  return Number.isFinite(time) ? time : null;
};

// API items carry workflowStatus; older/mock items carry status.
export function deliveryWorkflowStatus(item) {
  return String(
    item?.workflowStatus || item?.status || item?.publishState?.status || "",
  ).toLowerCase();
}

export function deliveryBucket(item, now = Date.now()) {
  const status = deliveryWorkflowStatus(item);
  const publishState = item?.publishState || {};

  if (status === "archived") return "history";

  const currentUntil = parseTime(publishState.showAsCurrentUntil);
  if (currentUntil !== null && currentUntil <= now) return "history";

  if (status === "in-review" || status === "draft") return "upcoming";

  const publishOn = parseTime(publishState.publishOn || item?.PublishOn);
  if (publishOn !== null && publishOn > now) return "upcoming";

  return "current";
}

export function splitDeliveryItems(items, now = Date.now()) {
  const buckets = { current: [], upcoming: [], history: [] };
  for (const item of Array.isArray(items) ? items : []) {
    const pinLevelPermissions = item.contentSettings?.pinLevelPermissions;
    const groups = String(item.contentSettings?.groups ?? item.groups ?? "")
      .split(",")
      .filter(Boolean)
      .map(Number);
    const normalizedItem = {
      ...item,
      ...(pinLevelPermissions == null
        ? {}
        : {
            pinPermissions: {
              ibo: !!(pinLevelPermissions & 2),
              platinum: !!(pinLevelPermissions & 4),
              emerald: !!(pinLevelPermissions & 8),
              diamond: !!(pinLevelPermissions & 16),
            },
          }),
      ...(item.contentSettings?.groups != null || item.groups != null
        ? {
            membershipPermissions: {
              complimentary: groups.includes(2),
              premier: groups.includes(1),
            },
          }
        : {}),
    };
    buckets[deliveryBucket(item, now)].push(normalizedItem);
  }
  return buckets;
}
